import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
const el = document.getElementById('dv-material-root');
if (el) {
    createRoot(el).render(_jsx(App, {}));
}
